const emergencySoundMap = {
    FIRE: "/bells/fire.mp3",
    EMERGENCY: "/bells/emergency.mp3",
    NATIONAL_ANTHEM: "/bells/national-anthem.mp3",
    INSTANT_BELL: "/bells/bell.mp3",
};

let activeEmergencyAudio = null;

export const stopEmergencyBell = () => {
    if (activeEmergencyAudio) {
        activeEmergencyAudio.pause();
        activeEmergencyAudio.currentTime = 0;
        activeEmergencyAudio = null;
    }
};

export const playEmergencyBellFromFrontend = async (emergencyType = "EMERGENCY") => {
    const soundUrl = emergencySoundMap[emergencyType] || emergencySoundMap.EMERGENCY;

    if (typeof Audio === "undefined") {
        return {
            status: 200,
            data: {
                emergencyType,
                soundUrl,
            },
        };
    }

    stopEmergencyBell();

    activeEmergencyAudio = new Audio(soundUrl);
    // Always play at full loudness.
    activeEmergencyAudio.volume = 1;
    activeEmergencyAudio.muted = false;
    activeEmergencyAudio.onended = () => {
        activeEmergencyAudio = null;
    };

    await activeEmergencyAudio.play();

    return {
        status: 200,
        data: {
            emergencyType,
            soundUrl,
        },
    };
};
